import IconMinus from "../../icons/icon-minus/icon-minus";
import IconPlusNotRounded from "../../icons/icon-plus-not-rounded/icon-plus-not-rounded";
import Icon from "../../icons/icon/icon";
import {ICollapsibleArrowProps} from "../collapsible.types";

export const TriggerPlus: React.FC<ICollapsibleArrowProps> = ({isExpanded}) => (
    <div className={`expandable-trigger-plus ${isExpanded ? 'is-expanded' : ''}`}>
        <Icon color={'var(--color-primary-2)'} Component={isExpanded ? IconMinus : IconPlusNotRounded} />
    </div>
);